import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-footer-bg text-text-accent">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <img
              src="/recit-logo.png"
              alt="Recit Logo"
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <h3 className="text-2xl font-bold mb-4 text-secondary">
              Redefining the Creator Economy
            </h3>
            <p className="text-text-secondary mb-6 leading-relaxed">
              Create. Collaborate. Earn.<br />
              Welcome to the next chapter of digital creativity.
            </p>
            <div className="flex items-center space-x-2 text-text-secondary">
              <MapPin className="h-5 w-5" />
              <span>Singapore</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-text-accent">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-text-secondary hover:text-secondary transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <a
                  href="https://go.recit.sg/s"
                  className="text-text-secondary hover:text-secondary transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Marketplace
                </a>
              </li>
              <li>
                <a
                  href="https://go.recit.sg/signup/customer"
                  className="text-text-secondary hover:text-secondary transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Start Selling
                </a>
              </li>
              <li>
                <a
                  href="https://go.recit.sg/login"
                  className="text-text-secondary hover:text-secondary transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Login
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-text-accent">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/terms" className="text-text-secondary hover:text-secondary transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-text-secondary hover:text-secondary transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-text-secondary text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Recit. All rights reserved.
          </p>
          <div className="flex items-center space-x-2 text-text-secondary text-sm">
            <Globe className="h-4 w-4" />
            <span>Built for creators worldwide</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;